module.exports = __webpack_public_path__ + "static/media/alarm2.f8fc9535.svg";